export enum TablePanels {
  NONE = 'none',
  LAYOUT = 'layout',
  BACKGROUND = 'background',
  BORDER = 'border',
  FILL = 'fill',
  FONT_ONE = 'font_one',
  FONT_TWO = 'font_two',
  OUTLINE = 'outline',
  HIGHLIGHTED_BACKGROUND = 'highlighted-background',
  HIGHLIGHTED_TEXT = 'highlighted-text',
  ANIMATION = 'animation',
}
